import { userManager } from '@/Core/Managers'
import { RevertResourceCorrespondenceConfig } from '../Configs/ResourceCorrespondenceConfig'

export const CheckGlobalResourceAccessTask = (resourceKey: string, operationKey: string) => {
    if (!resourceKey || !operationKey) {
        return false
    }

    const permissions = userManager.user?.['permissions']

    if (!permissions) {
        return false
    }

    const backendKey = RevertResourceCorrespondenceConfig?.[resourceKey]

    if (!backendKey) return false

    const backendPermission = permissions?.[backendKey]

    if (backendPermission && backendPermission?.[operationKey] === true) {
        return true
    }

    return false
}
